import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import { displayError } from '@/utils/functions/displayError';

export type ConfirmParams = {
  customerId: string;
  phoneNum: string;
  paymentMethod: string;
  amountPaidInRupee: string;
  paymentRefNo: string;
  weightInGram: string;
  transactionStatus: string;
  buyLotId: string;
};

const confirmBuy = (data: ConfirmParams) => {
  return axios.post(`dg/customers/${data.customerId}/buy-orders`, data);
};

export const useBuyConfirm = () => {
  const mutation = useMutation({
    mutationFn: confirmBuy,
  });

  useEffect(() => {
    displayError(mutation.error);
  }, [mutation.error]);

  return mutation;
};
